export const removeAllWhiteSpace = (stringToReplace) => {
    return stringToReplace.replace(/\s/g,'');
};